document.addEventListener( 'DOMContentLoaded', function () {
	const blocks = document.querySelectorAll( '.block-float-qr' );

	blocks.forEach( function ( block ) {
		const closeBtn = block.querySelector( '.block-float-qr__close' );
		const timeout = parseInt( block.dataset.timeout, 10 ) || 60;
		const verticalPosition = parseInt( block.dataset.verticalPosition, 10 ) || 50;

		if ( ! closeBtn ) {
			return;
		}

		// Проверяем localStorage — закрывали ли эту плашку
		const storageKey = 'float_qr_closed_' + window.location.pathname;
		const closedTime = localStorage.getItem( storageKey );

		if ( closedTime ) {
			const elapsed = ( Date.now() - parseInt( closedTime, 10 ) ) / 1000;
			if ( elapsed < timeout ) {
				block.style.display = 'none';
				return;
			} else {
				localStorage.removeItem( storageKey );
			}
		}

		block.style.display = '';

		// Читаем отступ из data-атрибута
		const marginTop = parseInt( block.dataset.marginTop, 10 ) || 0;

		let isFixed = false;
		let spacer = null;

		/**
		 * Переносит блок в body
		 */
		function initBlock() {
			document.body.appendChild( block );

			block.style.position = 'fixed';
			block.style.right = '0';
			block.style.marginTop = '';
			block.style.zIndex = '9999';
			block.style.maxWidth = '170px';
			block.style.display = '';
		}

		/**
		 * Обновляет положение блока — верхний край, никаких смещений
		 */
		function updateBlock() {
			const scrollY = window.scrollY;
			const triggerPx = window.innerHeight * ( verticalPosition / 100 );
			const threshold = marginTop - triggerPx;

			if ( scrollY >= threshold ) {
				if ( ! isFixed ) {
					isFixed = true;
				}
				block.style.top = triggerPx + 'px';
			} else {
				if ( isFixed ) {
					isFixed = false;
				}
				block.style.top = ( marginTop - scrollY ) + 'px';
			}
		}

		// Инициализация
		initBlock();
		updateBlock();

		window.addEventListener( 'scroll', updateBlock, { passive: true } );
		window.addEventListener( 'resize', function () {
			updateBlock();
		} );

		// Закрытие
		closeBtn.addEventListener( 'click', function ( e ) {
			e.preventDefault();
			isFixed = false;
			block.style.display = 'none';
			localStorage.setItem( storageKey, Date.now().toString() );
			window.removeEventListener( 'scroll', updateBlock );
		} );
	} );
} );